// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Z\\+B-re7Q{align-items:flex-start;display:flex}._8IZp2Fm2{flex-grow:1}.Eymtcv-\\+,._8IZp2Fm2{padding-bottom:var(--spacing-md)}.Eymtcv-\\+{flex-shrink:0;padding-left:var(--spacing-lg);position:sticky;top:var(--header-height)}@media(max-width:947.98px){.Eymtcv-\\+{display:none}}.tH77KEqg{height:17.5rem;-o-object-fit:contain;object-fit:contain;width:17.5rem}.\\+H9Y4958{word-wrap:anywhere;color:var(--color-gray-4);font-size:.88rem;line-height:1.43;max-width:17.5rem;padding:var(--spacing-xl);padding-bottom:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xs": "667.98",
	"sm": "947.98",
	"md": "1023.98",
	"lg": "1229.98",
	"container": "Z+B-re7Q",
	"formContainer": "_8IZp2Fm2",
	"aside": "Eymtcv-+",
	"banner": "tH77KEqg",
	"description": "+H9Y4958"
};
module.exports = ___CSS_LOADER_EXPORT___;
